<template>
    <tabs parent="simcard_profile_list">
        <tab
            id="sim_card_list"
            :name="translate('simcard_profile.many')"
            :href="url+'sim_card_list'"
        >
            <SimCardProfile />
        </tab>

        <tab
            id="groups"
            :name="translate('simcard_profile_group.many')"
            :href="url+'groups'"
        >
            <GroupList />
        </tab>

      <tab
          id="traffic_list"
          :name="translate('simcard_profile.traffic_list.title')"
          :href="url+'traffic_list'"
      >
        <TrafficList />
      </tab>

        <tab
            id="apn_list"
            :name="translate('simcard_profile.apn_lists')"
            :href="url+'apn_list'"
        >
            <ApnList />
        </tab>
    </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import SimCardProfile from "./Tabs/SimCardProfile/Index.vue";
import ApnList from "./Tabs/ApnList/Index.vue";
import TrafficList from "./Tabs/TrafficList/TrafficList.vue";
import GroupList from "./Tabs/GroupList/Index.vue";

export default {
    name: 'SimCardProfileBlock',
    components:{
        Tab,
        Tabs,
        SimCardProfile,
        ApnList,
        TrafficList,
        GroupList
    },
    computed: {
        url () { return '/simcard_profile_list/' },
    },
}
</script>
